import React from "react";
interface IconProps extends React.SVGProps<SVGSVGElement> {
  className?: string;
  color?: string;
}
const AddToPlaylist: React.FC<IconProps> = ({className, color = "#fff"}) => {
  return (
    <svg width="1em" height="1em" viewBox="0 0 39 43" fill="none" className={className}>
      <g filter="url(#prefix__filter0_d_4411_9871)">
        <path
          d="M30.006 32.805c2.46 0 4.453-1.709 4.453-3.817 0-2.107-1.994-3.816-4.453-3.816-2.459 0-4.452 1.709-4.452 3.816 0 2.108 1.993 3.817 4.452 3.817zM9.652 37.893c2.459 0 4.452-1.709 4.452-3.817s-1.993-3.816-4.452-3.816c-2.46 0-4.453 1.708-4.453 3.816 0 2.108 1.994 3.817 4.453 3.817z"
          stroke={color}
          strokeWidth={2.806}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15.508 22.517a8.972 8.972 0 01-2.806 0v12.196a1.403 1.403 0 002.806 0V22.517zm7.278-10.79l10.27-2.568v20.465a1.403 1.403 0 002.806 0V7.363A1.403 1.403 0 0034.12 6l-12.4 3.1a8.85 8.85 0 011.067 2.625z"
          fill={color}
        />
        <circle
          cx={13.647}
          cy={12.469}
          r={9.423}
          stroke={color}
          strokeWidth={2.525}
        />
        <g filter="url(#prefix__filter1_d_4411_9871)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M14.699 7.89V6.838h-2.105v4.58H8.015v2.104H12.594v4.58H14.7v-4.58H19.278v-2.104H14.7V7.89z"
            fill={color}
          />
        </g>
      </g>
      <defs>
        <filter
          id="prefix__filter0_d_4411_9871"
          x={0.722}
          y={0.672}
          width={37.379}
          height={41.99}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={1.128} />
          <feGaussianBlur stdDeviation={1.119} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_4411_9871"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect1_dropShadow_4411_9871"
            result="shape"
          />
        </filter>
        <filter
          id="prefix__filter1_d_4411_9871"
          x={5.776}
          y={5.727}
          width={15.742}
          height={15.742}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={1.128} />
          <feGaussianBlur stdDeviation={1.119} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_4411_9871"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect1_dropShadow_4411_9871"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};

const MemoAddToPlaylist = React.memo(AddToPlaylist);
export default MemoAddToPlaylist;
